import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import {
  fetchConfiguration,
  updateConfiguration,
  fetchPresignedS3UrlForGet,
} from '../../actions/configurationActions'
import { fetchAdminList } from '../admin/adminActions'
import { selectConfiguration } from '../../reducers/configurationReducer'
import { selectAdminUserList } from '../../reducers/adminUsers'
import { Configuration } from '../../core/types'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'
import ConfigurationForm from './configurationForm'

export interface Props {
  configuration: Configuration
  location: { key: any } & Location
  history: History
  fetchConfiguration: (id: string) => Promise<any>
  updateConfiguration: (id: string, values: any) => Promise<any>
  fetchAdminList: (badges?: any) => Promise<any>
  users: any[]
  match: { params: { id: string } }
}

interface State {
  loading: boolean
  isLoadingUsers: boolean
}

export class ConfigurationEdit extends Component<Props, State> {
  state = { loading: true, isLoadingUsers: true }

  componentDidMount() {
    this.loadConfiguration()
    this.loadUsers()
  }

  loadConfiguration = async () => {
    const { fetchConfiguration, match } = this.props
    this.setState({ loading: true })
    try {
      await fetchConfiguration(match.params.id)
    } finally {
      this.setState({ loading: false })
    }
  }

  loadUsers = async () => {
    const { fetchAdminList } = this.props
    this.setState({ isLoadingUsers: true })
    try {
      await fetchAdminList(null)
    } finally {
      this.setState({ isLoadingUsers: false })
    }
  }

  onSubmit = async (values) => {
    const { updateConfiguration, match, history } = this.props
    const updatedConfiguration = await updateConfiguration(
      match.params.id,
      values
    )
    if (updatedConfiguration && updatedConfiguration.id) {
      history.push(`/configuration/${updatedConfiguration.id}`)
    }
  }

  render() {
    const { configuration, users } = this.props
    const { loading, isLoadingUsers } = this.state

    if (loading) {
      return <LoadingSection isLoading>{null}</LoadingSection>
    }

    if (!configuration) {
      return <div>Configuration not found</div>
    }

    const levels = [
      { label: 'Index ', path: '/' },
      {
        label: 'Configurations',
        path: '/configuration',
      },
      { label: configuration.callCenterName, path: '' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <LoadingSection isLoading={loading}>
          <div className="index index__drive-america">
            <h1 className="index-table__header">Edit Configuration</h1>
            <ConfigurationForm
              initialValues={configuration}
              timezones={configuration.availableTimezones}
              users={users}
              isLoadingUsers={isLoadingUsers}
              onSubmit={this.onSubmit}
            />
          </div>
        </LoadingSection>
      </>
    )
  }
}

export const mapStateToProps = (state, props) => {
  const configuration = selectConfiguration(
    state.configurations,
    props.match.params.id
  )
  const currentOrg = configuration?.organization || null
  const allAdmins = selectAdminUserList(state.adminUsers)
  const filteredUsers = currentOrg
    ? allAdmins.filter((admin) => admin.organizationId === currentOrg.id)
    : allAdmins

  return {
    configuration,
    users: filteredUsers,
  }
}

export default withRouter(
  connect(mapStateToProps, (dispatch: any) => ({
    fetchConfiguration: (id: string) => dispatch(fetchConfiguration(id)),
    updateConfiguration: (id: string, values: any) =>
      dispatch(updateConfiguration(id, values)),
    fetchPresignedS3UrlForGet: (key: string) =>
      dispatch(fetchPresignedS3UrlForGet(key)),
    fetchAdminList: (badges?: any) => dispatch(fetchAdminList(badges)),
  }))(ConfigurationEdit)
)

